module.exports = __webpack_public_path__ + "c610add4cf2c8ed96e5657e2b5d01e6f.pdf";